"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _weirDls = require("@weirgroup/weir-dls");
var _sendminesiteinvitationModule = _interopRequireDefault(require("./sendminesiteinvitation.module.css"));
var _languageMsg = _interopRequireDefault(require("./languageMsg"));
class SendMinesiteInvitation extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.panelInline,
      "data-test": "main"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.panelLeft
    }, this.props.selectedAppRole.appRoleDisplayName && /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.chipList,
      "data-test": "chip"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.listLabel + ' ' + _sendminesiteinvitationModule.default.paddingBottom5
    }, _languageMsg.default.ROLE_LABEL), /*#__PURE__*/_react.default.createElement(_weirDls.Chip, {
      label: this.props.selectedAppRole.appRoleDisplayName,
      dismissiable: false,
      variant: 'filled'
    })), this.props.assignUsersValues.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.chipList
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.listLabel + ' ' + _sendminesiteinvitationModule.default.paddingBottom5
    }, this.props.mineSiteLabel.plural), this.props.assignUsersValues.map((user, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: _sendminesiteinvitationModule.default.chipWarpper + ' ' + _sendminesiteinvitationModule.default.paddingBottom5,
      "data-test": "chip"
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Chip, {
      dismissiable: true,
      variant: 'filled',
      label: user,
      onClick: () => {
        this.props.removeUser(user);
      }
    }), /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.panelRight
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.marginBottom24,
      "data-test": "sendButton"
    }, /*#__PURE__*/_react.default.createElement(_weirDls.Button, {
      onClick: this.props.onClickSendInvitation,
      label: _languageMsg.default.SEND_INVITATION_LABEL,
      variant: "primary"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.textLabel
    }, _languageMsg.default.SEND_INVITATION_INFO_TEXT1), /*#__PURE__*/_react.default.createElement("div", {
      className: _sendminesiteinvitationModule.default.textLabel
    }, _languageMsg.default.SEND_INVITATION_INFO_TEXT2.replace('<MineSiteLabel>', this.props.mineSiteLabel.singular))));
  }
}
const mapStateToProps = state => ({
  mineSiteLabel: state.manageYourTeam.mineSiteLabel
});
const mapDispatchToProps = () => ({});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SendMinesiteInvitation);